import * as React from 'react'
import { Typography, Icon } from '@design/pt-ui'

export type Props = {
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
}

const ErrorMessage = (props: Props) => {
  const { style = {}, className } = props

  const inlineStyle = className
    ? {}
    : {
        ...style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px 15px',
        borderRadius: 4,
        margin: 10,
      }

  return (
    <span style={inlineStyle} className={className}>
      <Icon sx={{ color: 'red', marginRight: '10px' }}>warning</Icon>
      <Typography variant="body1" sx={{ color: 'red' }}>
        {props.children}
      </Typography>
    </span>
  )
}

export default ErrorMessage
